import {useSelector,useDispatch} from 'react-redux'
import {selectProgressFilters,setFilters} from './slice'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Button from 'react-bootstrap/Button'

const DateRangeOptions = () => {
	const dispatch = useDispatch()
	const {daysBack} = useSelector(selectProgressFilters)
	const options = [
		{
			text:'1 Month',
			daysBack:31,
		},{
			text:'6 Months',
			daysBack:186
		},{
			text:'1yr',
			daysBack:365,
		},{
			text:'All',
			daysBack:-1
		}
	]
	return (
		<div className="text-center">
			<small className="d-block">Date Range</small>
			<ButtonGroup size="sm">
				{options.map(opt=>(
					<Button
						onClick={()=>{
							dispatch(setFilters({daysBack:opt.daysBack}))
						}}
						key={opt.text}
						variant={opt.daysBack===daysBack?"primary":"outline-primary"}
					>
						{opt.text}
					</Button>
				))}
			</ButtonGroup>
		</div>
	)
}

export default DateRangeOptions